import React from "react";
import "../supplierAndManufacturers.scss";

const HighlightInput = ({
  disable = false,
  value = '',
  placeholder = '',
  isError = false,
  errorText = 'Field cannot be empty',
  onChange = (value) => { },
  onBlur = (value) => { },
}) => {
  return (
    <div className="w-100">
      <div className={`${isError ? "input-error" : ""} d-flex align-items-center radius-4 highlight-input-with-grey-border p-2 w-100`}>
        <input
          disabled={disable}
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={(e) => { onChange(e?.target?.value) }}
          onBlur={(e) => { onBlur(e?.target?.value) }}
          className="bg-transparent border-none f-14 mr-1 f-black f-400 inputClassName w-100"
        />
      </div>
      {isError && (<div className="f-danger f-12">{errorText}</div>)}
    </div>
  );
};

export default HighlightInput;
